<template>
  <v-app id="login">
    <v-content>
      <v-container
              fluid
              fill-height
      >
        <v-layout
                align-center
                justify-center
        >
          <v-flex
                  xs12
                  sm8
                  md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                      color="primary"
                      dark
                      flat
              >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
<!--                <v-tooltip bottom>-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-btn-->
<!--                            :href="source"-->
<!--                            icon-->
<!--                            large-->
<!--                            target="_blank"-->
<!--                            v-on="on"-->
<!--                    >-->
<!--                      <v-icon>mdi-code-tags</v-icon>-->
<!--                    </v-btn>-->
<!--                  </template>-->
<!--                  <span>Source</span>-->
<!--                </v-tooltip>-->
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                          label="Login"
                          name="login"
                          v-model="email"
                          prepend-icon="person"
                          type="text"
                  ></v-text-field>

                  <v-text-field
                          id="password"
                          label="Password"
                          name="password"
                          v-model="password"
                          prepend-icon="lock"
                          type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="authorize()">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <base-material-snackbar
                v-model="snackbar"
                type="error"
                v-bind="{
        'bottom': true,
        'center': true
      }"
        >
          {{snackbar_text}}
        </base-material-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: "Login",
    data: () => ({
      drawer: null,
      email: '',
      password: '',
      snackbar: false,
      snackbar_text: 'Invalid Credentials'
      //
    }),
    computed: {
      ...mapState(['loggedIn'])
    },
    created() {
      if(this.loggedIn) {
        this.redirect("/bookings");
      }
    },
    methods: {
      ...mapActions({authenticate: 'AUTHENTICATE'}),
      async authorize() {
        await this.authenticate({email: this.email, password: this.password})
        if(this.loggedIn) {
          this.redirect("/bookings");
        } else {
          this.snackbar = true;
        }
      },
      redirect(path) {
        return this.$router.push(path);
      }
    }
  };
</script>
